@if (loading) {
  <app-please-wait></app-please-wait>
}

@if (!loading) {
  <div class="gateways-container days-{{ maximumDays }}">
    @for (gateway of results; track gateway) {
      <div class="gateway">
        <div class="row">
          <div class="col-sm-12 title">
            <span title="{{ gateway.id }}">{{ gateway.title }}</span>
          </div>
          <div class="col-sm-12">
            <div class="table assets">
              @for (asset of gateway.assets; track asset) {
                <div>
                  <span title="#{{ asset.id }}" class="title">
                    {{ asset.title }}
                  </span>
                  <span class="bars">
                    <app-setpoint-bars [screenAdjust]="false" [asset]="asset" [maximumDays]="maximumDays" [days]="asset.days" (onClick)="hasClicked($event)"></app-setpoint-bars>
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div class="well well-sm">
      Setpoint performance over the last
      <select (change)="maximumDaysChanged()" [(ngModel)]="requestedMaximumDays">
        <option value="30">30</option>
        <option value="60">60</option>
      </select>
      days.
    </div>
    @if (results.length === 0) {
      <div>
        <app-info-box title="No setpoints exist" link="Add setpoint" (trayLinkClicked)="gotoList()">Your organisation has not created any setpoints, when these are created traffic light statuses can be tracked here.</app-info-box>
      </div>
    }
  </div>
}
@if (sensorSelected) {
  <app-sensor-popup [show]="!!sensorSelected" (showChange)="sensorSelected = null" [asset]="sensorSelected" [startsAt]="startsAt" [endsAt]="endsAt" [showPoints]="true"></app-sensor-popup>
}
